import React, { useState, useEffect } from 'react';
import axios from 'axios';

function ClientReviews() {
  const [review, setReview] = useState('');
  const [name, setName] = useState('');
  const [designation, setDesignation] = useState('');
  const [company, setCompany] = useState('');
  const [reviews, setReviews] = useState([]);
  const [editingReview, setEditingReview] = useState(null); // Track the review being edited

  useEffect(() => {
    fetchReviews();
  }, []);

  const fetchReviews = async () => {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/jobs/getreviews`, {
        headers: { 'Authorization': `Bearer ${token}` }
      }); // Replace with your API endpoint
      setReviews(response.data);
    } catch (error) {
      console.error('Error fetching reviews:', error);
    }
  };

  const handleAddReview = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('accessToken');
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/jobs/addreview`, { review, name, designation, company }, {
        headers: { 'Authorization': `Bearer ${token}` }
      }); // Replace with your API endpoint
      setReview('');
      setName('');
      setDesignation('');
      setCompany('');
      fetchReviews();
    } catch (error) {
      console.error('Error adding review:', error);
    }
  };

  const handleEditReview = (reviewData) => {
    setEditingReview(reviewData);
    setReview(reviewData.review);
    setName(reviewData.name);
    setDesignation(reviewData.designation);
    setCompany(reviewData.company);
  };

  const handleUpdateReview = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('accessToken');
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/jobs/updatereview/${editingReview._id}`, { review, name, designation, company }, {
        headers: { 'Authorization': `Bearer ${token}` }
      }); // Replace with your API endpoint
      setEditingReview(null);
      setReview('');
      setName('');
      setDesignation('');
      setCompany('');
      fetchReviews();
    } catch (error) {
      console.error('Error updating review:', error);
    }
  };

  const handleDeleteReview = async (id) => {
    try {
      const token = localStorage.getItem('accessToken');
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/jobs/deletereview/${id}`, {}, {
        headers: { 'Authorization': `Bearer ${token}` }
      }); // Replace with your API endpoint
      fetchReviews();
    } catch (error) {
      console.error('Error deleting review:', error);
    }
  };

  return (
    <div className="p-8 bg-white rounded-lg shadow-md max-w-2xl mx-auto">
      <h2 className="text-3xl font-semibold text-gray-800 mb-6">Manage Client Reviews</h2>

      {/* Add Review Section */}
      <div className="mb-8 border p-4 rounded-md">
        <h3 className="text-xl font-semibold mb-4">Add Review</h3>
        <form onSubmit={editingReview ? handleUpdateReview : handleAddReview} className="space-y-4">
          <div>
            <label htmlFor="review" className="block text-sm font-medium text-gray-700">Review</label>
            <textarea
              id="review"
              value={review}
              onChange={(e) => setReview(e.target.value)}
              className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm p-2"
            />
          </div>
          <div>
            <label htmlFor="name" className="block text-sm font-medium text-gray-700">Name</label>
            <input
              type="text"
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm p-2"
            />
          </div>
          <div>
            <label htmlFor="designation" className="block text-sm font-medium text-gray-700">Designation</label>
            <input
              type="text"
              id="designation"
              value={designation}
              onChange={(e) => setDesignation(e.target.value)}
              className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm p-2"
            />
          </div>
          <div>
            <label htmlFor="company" className="block text-sm font-medium text-gray-700">Company</label>
            <input
              type="text"
              id="company"
              value={company}
              onChange={(e) => setCompany(e.target.value)}
              className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm p-2"
            />
          </div>
          <button
            type="submit"
            className="bg-indigo-600 hover:bg-indigo-700 text-white py-2 px-4 rounded-md"
          >
            {editingReview ? 'Update Review' : 'Add Review'}
          </button>
          {editingReview && (
            <button
              type="button"
              className="bg-gray-300 hover:bg-gray-400 py-2 px-4 rounded-md ml-2"
              onClick={() => {
                setEditingReview(null);
                setReview('');
                setName('');
                setDesignation('');
                setCompany('');
              }}
            >
              Cancel Edit
            </button>
          )}
        </form>
      </div>

      {/* Edit Reviews Section */}
      <div>
        <h3 className="text-xl font-semibold mb-4">Edit Reviews</h3>
        <div className="space-y-4">
          {reviews.map((reviewData) => (
            <div key={reviewData._id} className="border p-4 rounded-md flex justify-between gap-2 items-center">
              <div className='w-full'>
                <p className="font-semibold">{reviewData.name}</p>
                <p>{reviewData.review.substring(0, 100)}...</p>
              </div>
              <div className="w-fit flex flex-col">
                <button
                  onClick={() => handleEditReview(reviewData)}
                  className="bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 rounded-md w-full"
                >
                  Edit
                </button>
                <button
                  onClick={() => handleDeleteReview(reviewData._id)}
                  className="bg-red-500 hover:bg-red-600 text-white py-2 px-4 rounded-md w-full"
                >
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ClientReviews;